import { render, staticRenderFns } from "./pi4-person-warning.vue?vue&type=template&id=709f6aec"
import script from "./pi4-person-warning.vue?vue&type=script&lang=js"
export * from "./pi4-person-warning.vue?vue&type=script&lang=js"
import style0 from "./pi4-person-warning.vue?vue&type=style&index=0&id=709f6aec&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports